import React, { useMemo, useRef, useState } from 'react';
import { BtnComponent } from '../../components/button';
import SpeechMic from '../../components/mic';
import { useSendMessageMutation } from '../../services/chatService';
import { useGroupChatContext } from '../../context/groupchatContext';
import { toast } from 'react-toastify';

const BotchatFooter = React.memo(({msgDetail, setMsgDetail, summaryForProvider, closeChatbotPopup}) => {

    const [msgText, setMsgText] = useState('');
    const textareaRef = useRef(null);
    const [sendMessage, {isLoading}] = useSendMessageMutation();

    const groupChatContext = useGroupChatContext();
    const {selectedChat} = useMemo(() => ({
        selectedChat: groupChatContext.selectedChat,
    }));
     
    const onKeyPress = (e) => {
        const pressedKey = e.key;
        if(pressedKey == "Enter" && !e.shiftKey){
            e.preventDefault();
            if(msgText.trim()){
                handleSendMessage();
            }
        }
    }

    const handleSendMessage = () => {
        setMsgText('');
        setMsgDetail({...msgDetail, description: msgText.trim()})
    };

    const onSpeechAvailable = (text) =>{
        setMsgText(text.trim())
    }

    const sendSummaryToProvider = async (text) =>{
        const payload = {pid: selectedChat?.pid, location_id: selectedChat?.location?.id || selectedChat?.location_id, message:{type: 'event', event_type: 'change_status', data: {text: summaryForProvider}}};
        const res = await sendMessage(payload);
        if(res?.data?.code === 0){
            closeChatbotPopup();
        }
        else {
            toast.error(res?.data?.msg);
        }
    }




    return (
        <div className='p-4 bg-white border-t border-gray-200 relative w-full'>
            {!summaryForProvider ? <div className="placeholder:text-black  basic-multi-select placeholder:font-normal  placeholder:text-base ui-control-input flex items-end rounded-c-full gap-3">
                <SpeechMic transformSpeech={onSpeechAvailable} divCls=' ' />
                <div className="relative w-full">
                    <div className="border border-gray-300 rounded-lg p-1">
                        <div className="flex items-center gap-2">
                            <textarea
                                type="text"
                                rows={Math.min(msgText.split('\n').length, 3)} // Adjust the number of rows based on the content
                                value={msgText}
                                ref={textareaRef}
                                onKeyPress={onKeyPress}
                                onChange={(e)=>setMsgText(e?.target?.value)}
                                placeholder="Type your message..."
                                className={`flex-1 ml-2 w-full py-1 rounded-md focus:outline-none resize-none min-h-8`}
                            />
                        </div>
                    </div>
                </div>
                <BtnComponent btnType='primary_theme' className={`px-4 items-center`} type="submit" disabled={!msgText.trim()} onClick={handleSendMessage} text="Send" />
            </div> : <div className="placeholder:text-black basic-multi-select placeholder:font-normal placeholder:text-base ui-control-input rounded-c-full gap-1 w-full">
                <BtnComponent btnType='primary_theme' loading={isLoading} className={`px-4 text-[16px] w-[15rem] text-center justify-center mx-auto`} type="submit" onClick={sendSummaryToProvider} text="Send to Provider" />
            </div>}
        </div>
    );
});

export default BotchatFooter;